import { createFeatureSelector } from '@ngrx/store';
import { RefundTokenMapState } from '../reducers/refund-token-map.reducer';

export const selectRefundTokenMap = createFeatureSelector<RefundTokenMapState>('refundTokenMap');
